import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { Form, Button, Container, Row, Col, FormSelect } from "react-bootstrap";
import { ToastContainer } from 'react-toastify';
import { fnFormValidation, fnMobileNumberValidation, fnEmailValidation } from '../reusables/HelperFormValidation';
import { fnOnChange, showToast } from '../reusables/CommonFunction';
import axiosInstance from '../../utils/axios';
import BusyLoaderOverlay from '../reusables/BusyLoaderOverlay';

const initialState = {
    start_date: "",
    clinic_name: "",
    clinic_type: "",
    doctor_name: "",
    doctor_profession: "",
    doctor_type: "",
    referred_by: "",
    registration_number: "",
    doctor_degree: "",
    mobile_number: "",
    alternate_mobile_number: "",
    brevo_whatsapp_business_number: "",
    email_id: "",
    clinic_website: "",
    communication_status: "A",
    communication_sms_status: "A",
    communication_whatsapp_status: "A",
    communication_email_status: "A",
    plan_type: "",
    clinic_address: "",
};

const initialStateErrors = {
    start_date: "",
    expiring_date: "",
    clinic_name: "",
    clinic_type: "",
    doctor_name: "",
    doctor_profession: "",
    doctor_type: "",
    referred_by: "",
    registration_number: "",
    doctor_degree: "",
    mobile_number: "",
    alternate_mobile_number: "",
    brevo_whatsapp_business_number: "",
    email_id: "",
    clinic_website: "",
    communication_status: "",
    communication_sms_status: "",
    communication_whatsapp_status: "",
    communication_email_status: "",
    plan_type: "",
    clinic_address: "",
};

const NewClinic = () => {
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false);
    const [newClinicState, setNewClinicState] = useState(initialState);
    const [newClinicErrors, setNewClinicErrors] = useState(initialStateErrors);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const onPressNewClinic = (oEvent) => {
        oEvent.preventDefault();
        setIsSubmitting(true);
        const aErrorMessage = ['start_date', 'clinic_name', 'clinic_type', 'doctor_name', 'doctor_profession', 'doctor_type', 'referred_by', 'registration_number', 'doctor_degree', 'mobile_number', 'email_id', 'communication_status', 'communication_sms_status', 'communication_whatsapp_status', 'communication_email_status', 'plan_type', 'clinic_address']
        const fErrorStatus = fnFormValidation(newClinicState, newClinicErrors, setNewClinicErrors, aErrorMessage)

        if (fErrorStatus.length === 0) {
            const aMobileNumberCheck = ['mobile_number', 'alternate_mobile_number', 'brevo_whatsapp_business_number']
            const aMobileErrors = fnMobileNumberValidation(newClinicState, newClinicErrors, setNewClinicErrors, aMobileNumberCheck, fErrorStatus)

            const aEmailCheck = ['email_id']
            const aEmailErrors = fnEmailValidation(newClinicState, newClinicErrors, setNewClinicErrors, aEmailCheck, fErrorStatus)

            fErrorStatus.push(...aMobileErrors, ...aEmailErrors);
        }

        if (fErrorStatus.length === 0) {
            setLoading(true);
            axiosInstance
                .post(`/clinics/`, newClinicState)
                .then(response => {
                    if (response.status === 201) {
                        showToast("success", response.data.message, { onClose: () => navigate("/clinic", { replace: true }) });
                        setNewClinicState(initialState);
                        setNewClinicErrors(initialStateErrors);
                    }
                })
                .catch(error => {
                    const errorData = error.response?.data;
                    if (errorData) {
                        Object.keys(errorData).forEach((key, index) => {
                            let sError = Array.isArray(errorData[key]) ? errorData[key][0] : errorData[key];
                            if (sError.includes("clinic_detail")) {
                                sError = sError.replace("clinic_detail", "Clinic Details");
                            }
                            if (sError.includes("clinic_ detail")) {
                                sError = sError.replace("clinic_ detail", "Clinic Details");
                            }
                            showToast("error", sError, { toastId: index });
                        });
                    } else {
                        showToast("error", "An unexpected error occurred. Please try again.");
                    }
                })
                .finally(() => {
                    setIsSubmitting(false);
                    setLoading(false);
                });

        } else {
            fErrorStatus.forEach((error) => {
                showToast("error", error, { toastId: error });
            });
            setIsSubmitting(false);
        }
    }

    return (
        <>
            <Container className="ml-3 mr-3 mb-3">
                <Row>
                    <div className='col-md-12'>
                        <div className='content-section col-md-8'>
                            <legend className="border-bottom mb-4">Create New Clinic</legend>
                            <Form autoComplete="off" noValidate>
                                <Form.Group className="mb-3" controlId="formClinicName">
                                    <Form.Label className="required">Clinic Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="clinic_name"
                                        placeholder='Clinic Name'
                                        value={newClinicState.clinic_name || ""}
                                        onChange={(oEvent) => fnOnChange(oEvent, newClinicState, setNewClinicState, newClinicErrors, setNewClinicErrors)}
                                        isInvalid={newClinicErrors.clinic_name}
                                    />
                                    <Form.Control.Feedback type="invalid">{newClinicErrors.clinic_name}</Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group className="mb-3" controlId="formDoctorName">
                                    <Form.Label className="required">Doctor Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="doctor_name"
                                        placeholder='Doctor Name'
                                        value={newClinicState.doctor_name || ""}
                                        onChange={(oEvent) => fnOnChange(oEvent, newClinicState, setNewClinicState, newClinicErrors, setNewClinicErrors)}
                                        isInvalid={newClinicErrors.doctor_name}
                                    />
                                    <Form.Control.Feedback type="invalid">{newClinicErrors.doctor_name}</Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group className="mb-3" controlId="formDoctorProfession">
                                    <Form.Label className="required">Doctor Profession</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="doctor_profession"
                                        placeholder='Doctor Profession'
                                        value={newClinicState.doctor_profession || ""}
                                        onChange={(oEvent) => fnOnChange(oEvent, newClinicState, setNewClinicState, newClinicErrors, setNewClinicErrors)}
                                        isInvalid={newClinicErrors.doctor_profession}
                                    />
                                    <Form.Control.Feedback type="invalid">{newClinicErrors.doctor_profession}</Form.Control.Feedback>
                                </Form.Group>

                                <Row className="mb-3">
                                    <Form.Group as={Col} controlId="formClinicType">
                                        <Form.Label className="required">Clinic Type</Form.Label>
                                        <Form.Control
                                            as={FormSelect}
                                            name="clinic_type"
                                            value={newClinicState.clinic_type || ""}
                                            onChange={(oEvent) => fnOnChange(oEvent, newClinicState, setNewClinicState, newClinicErrors, setNewClinicErrors)}
                                            isInvalid={newClinicErrors.clinic_type}>
                                            <option value="">Select Clinic Type</option>
                                            <option value="AL">Allopathy</option>
                                            <option value="HM">Homeopathy</option>
                                        </Form.Control>
                                        <Form.Control.Feedback type="invalid">{newClinicErrors.clinic_type}</Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group as={Col} controlId="formDoctorType">
                                        <Form.Label className="required">Doctor Type</Form.Label>
                                        <Form.Control
                                            as={FormSelect}
                                            name="doctor_type"
                                            value={newClinicState.doctor_type || ""}
                                            onChange={(oEvent) => fnOnChange(oEvent, newClinicState, setNewClinicState, newClinicErrors, setNewClinicErrors)}
                                            isInvalid={newClinicErrors.doctor_type}>
                                            <option value="">Select Doctor Type</option>
                                            <option value="dentist">Dentist</option>
                                            <option value="dermatologist">Dermatologist</option>
                                            <option value="ent_specialist">ENT Specialist</option>
                                            <option value="gastroenterologist">Gastroenterologist</option>
                                            <option value="general_practitioner">General Practitioner</option>
                                            <option value="gynecologist">Gynecologist</option>
                                            <option value="homeopathy">Homeopathy</option>
                                            <option value="orthopedic">Orthopedic</option>
                                            <option value="pediatrician">Pediatrician</option>
                                            <option value="physiotherapist">Physiotherapist</option>
                                            <option value="psychiatrist">Psychiatrist</option>
                                            <option value="psychologist">Psychologist</option>
                                        </Form.Control>
                                        <Form.Control.Feedback type="invalid">{newClinicErrors.doctor_type}</Form.Control.Feedback>
                                    </Form.Group>
                                </Row>

                                <Row className="mb-3">
                                    <Form.Group as={Col} controlId="formStartDate">
                                        <Form.Label className="required">Start Date</Form.Label>
                                        <Form.Control
                                            type="date"
                                            name="start_date"
                                            value={newClinicState.start_date || ""}
                                            onChange={(oEvent) => fnOnChange(oEvent, newClinicState, setNewClinicState, newClinicErrors, setNewClinicErrors)}
                                            isInvalid={newClinicErrors.start_date}
                                        />
                                        <Form.Control.Feedback type="invalid">{newClinicErrors.start_date}</Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group as={Col} controlId="formReferredBy">
                                        <Form.Label className="required">Referred By</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="referred_by"
                                            placeholder='Referred By'
                                            value={newClinicState.referred_by || ""}
                                            onChange={(oEvent) => fnOnChange(oEvent, newClinicState, setNewClinicState, newClinicErrors, setNewClinicErrors)}
                                            isInvalid={newClinicErrors.referred_by}
                                        />
                                        <Form.Control.Feedback type="invalid">{newClinicErrors.referred_by}</Form.Control.Feedback>
                                    </Form.Group>
                                </Row>

                                <Row className="mb-3">
                                    <Form.Group as={Col} controlId="formDoctorDegree">
                                        <Form.Label className="required">Doctor Degree</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="doctor_degree"
                                            placeholder='Doctor Degree'
                                            value={newClinicState.doctor_degree || ""}
                                            onChange={(oEvent) => fnOnChange(oEvent, newClinicState, setNewClinicState, newClinicErrors, setNewClinicErrors)}
                                            isInvalid={newClinicErrors.doctor_degree}
                                        />
                                        <Form.Control.Feedback type="invalid">{newClinicErrors.doctor_degree}</Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group as={Col} controlId="formRegistrationNumber">
                                        <Form.Label className="required">Registration Number</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="registration_number"
                                            placeholder='Registration Number'
                                            value={newClinicState.registration_number || ""}
                                            onChange={(oEvent) => fnOnChange(oEvent, newClinicState, setNewClinicState, newClinicErrors, setNewClinicErrors)}
                                            isInvalid={newClinicErrors.registration_number}
                                        />
                                        <Form.Control.Feedback type="invalid">{newClinicErrors.registration_number}</Form.Control.Feedback>
                                    </Form.Group>
                                </Row>

                                <Row className="mb-3">
                                    <Form.Group as={Col} controlId="formMobileNumber">
                                        <Form.Label className="required">Mobile Number</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="mobile_number"
                                            placeholder='Mobile Number'
                                            value={newClinicState.mobile_number || ""}
                                            onChange={(oEvent) => fnOnChange(oEvent, newClinicState, setNewClinicState, newClinicErrors, setNewClinicErrors)}
                                            isInvalid={newClinicErrors.mobile_number}
                                        />
                                        <Form.Control.Feedback type="invalid">{newClinicErrors.mobile_number}</Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group as={Col} controlId="formAltMobileNumber">
                                        <Form.Label>Alternate Mobile Number</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="alternate_mobile_number"
                                            placeholder='Altername Mobile Number'
                                            value={newClinicState.alternate_mobile_number || ""}
                                            onChange={(oEvent) => fnOnChange(oEvent, newClinicState, setNewClinicState, newClinicErrors, setNewClinicErrors)}
                                            isInvalid={newClinicErrors.alternate_mobile_number}
                                        />
                                        <Form.Control.Feedback type="invalid">{newClinicErrors.alternate_mobile_number}</Form.Control.Feedback>
                                    </Form.Group>
                                </Row>

                                <Form.Group className="mb-3" controlId="formBrevoWhatsappBusinessNumber">
                                    <Form.Label>Brevo WhatsApp Business Number</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="brevo_whatsapp_business_number"
                                        placeholder='Brevo WhatsApp Business Number'
                                        value={newClinicState.brevo_whatsapp_business_number || ""}
                                        onChange={(oEvent) => fnOnChange(oEvent, newClinicState, setNewClinicState, newClinicErrors, setNewClinicErrors)}
                                        isInvalid={newClinicErrors.brevo_whatsapp_business_number}
                                    />
                                    <Form.Control.Feedback type="invalid">{newClinicErrors.brevo_whatsapp_business_number}</Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group className="mb-3" controlId="formEmailAddress">
                                    <Form.Label className="required">Email Address</Form.Label>
                                    <Form.Control
                                        type="email"
                                        name="email_id"
                                        placeholder='Email Address'
                                        value={newClinicState.email_id || ""}
                                        onChange={(oEvent) => fnOnChange(oEvent, newClinicState, setNewClinicState, newClinicErrors, setNewClinicErrors)}
                                        isInvalid={newClinicErrors.email_id}
                                    />
                                    <Form.Control.Feedback type="invalid">{newClinicErrors.email_id}</Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group className="mb-3" controlId="formWebsite">
                                    <Form.Label>Website</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="clinic_website"
                                        placeholder='Website'
                                        value={newClinicState.clinic_website || ""}
                                        onChange={(oEvent) => fnOnChange(oEvent, newClinicState, setNewClinicState, newClinicErrors, setNewClinicErrors)}
                                        isInvalid={newClinicErrors.clinic_website}
                                    />
                                    <Form.Control.Feedback type="invalid">{newClinicErrors.clinic_website}</Form.Control.Feedback>
                                </Form.Group>

                                <Row className="mb-3">
                                    <Form.Group as={Col} controlId="formCommunicationStatus">
                                        <Form.Label className="required">Communication Status</Form.Label>
                                        <Form.Control
                                            as={FormSelect}
                                            name="communication_status"
                                            value={newClinicState.communication_status || ""}
                                            onChange={(oEvent) => fnOnChange(oEvent, newClinicState, setNewClinicState, newClinicErrors, setNewClinicErrors)}
                                            isInvalid={newClinicErrors.communication_status}>
                                            <option value="">Select Communication Option</option>
                                            <option value="A">Active</option>
                                            <option value="D">Deactive</option>
                                        </Form.Control>
                                        <Form.Control.Feedback type="invalid">{newClinicErrors.communication_status}</Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group as={Col} controlId="formCommunicationEmailStatus">
                                        <Form.Label className="required">Email Communication Status</Form.Label>
                                        <Form.Control
                                            as={FormSelect}
                                            name="communication_email_status"
                                            value={newClinicState.communication_email_status || ""}
                                            onChange={(oEvent) => fnOnChange(oEvent, newClinicState, setNewClinicState, newClinicErrors, setNewClinicErrors)}
                                            isInvalid={newClinicErrors.communication_email_status}>
                                            <option value="">Select Communication Option</option>
                                            <option value="A">Active</option>
                                            <option value="D">Deactive</option>
                                        </Form.Control>
                                        <Form.Control.Feedback type="invalid">{newClinicErrors.communication_email_status}</Form.Control.Feedback>
                                    </Form.Group>
                                </Row>

                                <Row className="mb-3">
                                    <Form.Group as={Col} controlId="formCommunicationSmsStatus">
                                        <Form.Label className="required">SMS Communication Status</Form.Label>
                                        <Form.Control
                                            as={FormSelect}
                                            name="communication_sms_status"
                                            value={newClinicState.communication_sms_status || ""}
                                            onChange={(oEvent) => fnOnChange(oEvent, newClinicState, setNewClinicState, newClinicErrors, setNewClinicErrors)}
                                            isInvalid={newClinicErrors.communication_sms_status}>
                                            <option value="">Select Communication Option</option>
                                            <option value="A">Active</option>
                                            <option value="D">Deactive</option>
                                        </Form.Control>
                                        <Form.Control.Feedback type="invalid">{newClinicErrors.communication_sms_status}</Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group as={Col} controlId="formCommunicationWhatsappStatus">
                                        <Form.Label className="required">WhatsApp Communication Status</Form.Label>
                                        <Form.Control
                                            as={FormSelect}
                                            name="communication_whatsapp_status"
                                            value={newClinicState.communication_whatsapp_status || ""}
                                            onChange={(oEvent) => fnOnChange(oEvent, newClinicState, setNewClinicState, newClinicErrors, setNewClinicErrors)}
                                            isInvalid={newClinicErrors.communication_whatsapp_status}>
                                            <option value="">Select Communication Option</option>
                                            <option value="A">Active</option>
                                            <option value="D">Deactive</option>
                                        </Form.Control>
                                        <Form.Control.Feedback type="invalid">{newClinicErrors.communication_whatsapp_status}</Form.Control.Feedback>
                                    </Form.Group>
                                </Row>

                                <Form.Group className="mb-3" controlId="formPlanType">
                                    <Form.Label className="required">Plan Type</Form.Label>
                                    <Form.Control
                                        as={FormSelect}
                                        name="plan_type"
                                        value={newClinicState.plan_type || ""}
                                        onChange={(oEvent) => {
                                            // Handle the change event for plan_type
                                            fnOnChange(oEvent, newClinicState, setNewClinicState, newClinicErrors, setNewClinicErrors)

                                            // if plan type is F then add 30 days to start date
                                            if (oEvent.target.value === 'F') {
                                                const startDate = new Date(newClinicState.start_date);
                                                startDate.setDate(startDate.getDate() + 30);
                                                setNewClinicState(prevState => ({
                                                    ...prevState,
                                                    expiring_date: startDate.toISOString().split('T')[0] // Format to YYYY-MM-DD
                                                }));
                                            } else if (oEvent.target.value === 'P') {
                                                setNewClinicState(prevState => ({
                                                    ...prevState,
                                                    expiring_date: null // Reset expiring date for paid plan
                                                }));
                                            }
                                        }}
                                        isInvalid={newClinicErrors.plan_type}>
                                        <option value="">Select Plan Type</option>
                                        <option value="F">Free Trial Plan</option>
                                        <option value="P">Paid Subscription Plan</option>
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">{newClinicErrors.plan_type}</Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group className="mb-3" controlId="formClinicAddress">
                                    <Form.Label className="required">Clinic Address</Form.Label>
                                    <Form.Control as="textarea" rows={3}
                                        name="clinic_address"
                                        placeholder='Clinic Address'
                                        value={newClinicState.clinic_address || ""}
                                        onChange={(oEvent) => fnOnChange(oEvent, newClinicState, setNewClinicState, newClinicErrors, setNewClinicErrors)}
                                        isInvalid={newClinicErrors.clinic_address}
                                    />
                                    <Form.Control.Feedback type="invalid">{newClinicErrors.clinic_address}</Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group className="mb-3" controlId="formLogin">
                                    <Button type="submit" variant="primary" className="form-control" onClick={onPressNewClinic} disabled={isSubmitting}>
                                        {isSubmitting ? "Submitting..." : "Submit"}
                                    </Button>
                                </Form.Group>
                            </Form>
                            <ToastContainer />
                        </div>
                    </div>
                </Row>
            </Container>
            <BusyLoaderOverlay show={loading} />
        </>
    )
}

export default NewClinic